import { Box, Flex } from "@chakra-ui/react";
import DashboardRelatorioReservas from "./../DashboardRelatorioReservas/index";
import TableRelatorioReservas from "./../TableRelatorioReservas/index";
import ListingPageHeaderBar from "ui/components/Page/ListingPageHeaderBar";
import useFiltroRelatorioReservas from "../../hooks/useFiltroRelatorioReservas";
import { useState, useCallback, useRef } from "react";
import ExportMenu from "components/ExportMenu";
import DateRangePicker from "components/Input/DateRangePicker";
import PageHeader from "components/Page/PageHeader";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import ModalFiltros from "./../../../../Administracao/Reservas/Listagem/components/ModalFiltros/index";
import FiltroTags from "../FiltroTags";
import useDownloadRenderedPdf from "infra/helpers/useDownloadRenderedPdf";
import moment from "moment";
import useRelatorioReservasPdf from "features/relatorios/hooks/useRelatorioReservasPdf";
import PDFRelatorioRelatorioReservas from "./../PDFRelatorio/index";
import useRelatorioReservas from "core/features/relatorios/hooks/useRelatorioReservas";
import useRelatorioReservasDashboard from "features/relatorios/hooks/useRelatorioReservasDashboard";
import { AssinaturasItem } from "components/Relatorio/FormAssinaturas";
import ModalAssinaturasRelatorio from "components/Relatorio/ModalAssinaturas";
import { exportExcelRelatorioReservas } from "../util/helper";
import SelectTipoDataReservas from "components/Input/SelectTipoDataReservas";

export default function ListaRelatorioReservas() {
  const { filtro, onChangeFiltro, onResetFiltro } =
    useFiltroRelatorioReservas();
  const [isOpenModalFiltro, setIsOpenModalFiltro] = useState(true);
  const enableQuery = useRef(false);
  const { data, isLoading } = useRelatorioReservas(filtro, enableQuery.current);
  const { data: dataDashboard, isLoading: isLoadingDashboard } =
    useRelatorioReservasDashboard(filtro, enableQuery.current);

  const { tenant } = useCurrentTenant();
  const [modalAssinaturasOpen, setModalAssinaturasOpen] = useState(false);

  const {
    refetch: refetchPdf,
    isLoading: isLoadingPdf,
    isFetching: isFetchingPdf,
  } = useRelatorioReservasPdf(filtro);

  const { onDownload: onExportPdf } = useDownloadRenderedPdf({
    fileName: `Relatório de Reservas - ${moment().format("DD_MM_YYYY")}`,
    Component: PDFRelatorioRelatorioReservas,
    loading: isLoadingPdf || isFetchingPdf,
  });

  const _onExportPdf = useCallback(async () => {
    setModalAssinaturasOpen(true);
  }, []);

  const onSubmitAssinaturas = (assinaturas: AssinaturasItem[]) => {
    refetchPdf().then(({ data: dataExport }) => {
      if (dataExport) {
        onExportPdf({ data: { ...dataExport, assinaturas } });
        setModalAssinaturasOpen(false);
      }
    });
  };

  const onExportExcel = () => {
    refetchPdf().then(({ data: dataExport }) => {
      if (dataExport) {
        exportExcelRelatorioReservas({
          data: dataExport,
        });
      }
    });
  };

  const numeroFiltroSelecionados =
    (filtro.pessoaId ? 1 : 0) +
    (filtro.dataInicio || filtro.dataFim ? 1 : 0) +
    (filtro.status ? 1 : 0) +
    (filtro.unidadeId ? 1 : 0) +
    (filtro.areaComumId ? 1 : 0) +
    (filtro.tipoAreaComumIds ? 1 : 0);

  return (
    <Box>
      <PageHeader
        title="Reservas"
        midComponent={
          <Flex mt="4px" gap={4}>
            <DateRangePicker
              allowEmptyDates={{
                dataInicio: true,
                dataFim: false,
              }}
              onChange={(dataInicio, dataFim) => {
                onChangeFiltro({
                  dataInicio,
                  dataFim,
                });
              }}
              value={{
                dataInicio: filtro.dataInicio,
                dataFim: filtro.dataFim,
              }}
            />

            <Flex w="200px">
              <SelectTipoDataReservas
                allowClear={true}
                bg="white"
                style={{ border: "1px solid #ccc", borderRadius: 6 }}
                value={filtro.tipoData}
                onChange={(v) => onChangeFiltro({ tipoData: v })}
              />
            </Flex>
          </Flex>
        }
      />
      <DashboardRelatorioReservas
        data={dataDashboard}
        loading={isLoadingDashboard}
        filtro={filtro}
        onChangeFiltro={onChangeFiltro}
      />
      <Box mb={10}>
        <ListingPageHeaderBar
          valueSearch={filtro.search || ""}
          onSearch={(v) => onChangeFiltro({ search: v })}
          visibleFiltro
          showOrderByButton={false}
          badge
          badgeValue={numeroFiltroSelecionados}
          onFiltro={() => setIsOpenModalFiltro(true)}
          children={
            <Flex alignItems="center" w="100%" justifyContent="space-between">
              <FiltroTags
                value={filtro.status}
                onChange={(v) => onChangeFiltro({ status: v ?? undefined })}
              />
              <ExportMenu
                onExportPdf={_onExportPdf}
                onExportarXlsx={onExportExcel}
              />
            </Flex>
          }
        />
      </Box>

      <TableRelatorioReservas
        data={data}
        isLoading={isLoading}
        onChangeFiltro={onChangeFiltro}
      />

      {isOpenModalFiltro ? (
        <ModalFiltros
          tenantId={tenant.id}
          selectTipoDataReservas
          isOpen={isOpenModalFiltro}
          onClose={() => setIsOpenModalFiltro(false)}
          onSave={() => {
            enableQuery.current = true;
            setIsOpenModalFiltro(false);
          }}
          filtro={filtro}
          onChangeFiltro={onChangeFiltro}
          onReset={onResetFiltro}
        />
      ) : null}

      <ModalAssinaturasRelatorio
        isOpenModal={modalAssinaturasOpen}
        onClose={() => setModalAssinaturasOpen(false)}
        onSubmit={onSubmitAssinaturas}
      />
    </Box>
  );
}
